import axios from "axios";
import { ToastContainer } from "react-toastify";
import Toast from "../Components/ToastMsg/Toast";
import { ROUTE_MOBILE_VERIFICATION,Dexter_Splash3 } from "../Routes";

const instance = axios.create();
let ShowToast = false;

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      if (!ShowToast) {
        ShowToast = true;
        Toast.error("Session expired. Please login again");
      }
      window.location.replace(Dexter_Splash3);
    }
    return Promise.reject(error);
  }
);
<ToastContainer />;
export default instance;